import React from 'react';
import '../styles/components/modalCloseButton.css';

interface ModalCloseButtonProps {
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ onClick, className, style }) => (
  <button
    className={`modal-close-x${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label="Close"
    style={style}
  >
    <svg viewBox="0 0 24 24">
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </svg>
  </button>
);

export default ModalCloseButton;
